<app-header/>

<div class="row expanded goods">

  <div class="cross">
    <a class="close-modal" (click)="closeModal()"></a>
  </div>
  <app-categories-menu
    *ngIf="categoriesSortedDeep && categoriesSortedDeep.length"
    [headCategoryName]="headCategoryName"
    [subHeadCategoryName]="subHeadCategoryName"
    [headCategoryNameColored]="headCategoryNameColored"
    [categoryHeadShow]="categoryHeadShow"
    [has_cards]="has_cards"
    [categoriesSortedDeep]="categoriesSortedDeep"
    [brandsSorted]="brandsSorted"
    [urlParams]="urlParams"
    [calcDebt]="calcDebt"
    (buildCategoriesMenuGoodsData)="buildCategoriesMenuGoodsData()"
    (showModalPaymentRef)="showModalPayment()"
  />

  <div class="column size-head-category">
    <app-navigation-menu
      *ngIf="categoriesSortedDeep && categoriesSortedDeep.length"
      [selectedUser]="selectedUser"
      [selectedUserAdmin]="selectedUserAdmin"
      [headCategoryNameColored]="headCategoryNameColored"
      [headCategoryName]="headCategoryName"
      [subHeadCategoryName]="subHeadCategoryName"
      [allowLoginUsers]="allowLoginUsers"
      [userListAdmin]="userListAdmin"
      [deliveryInfo]="deliveryInfo"
      [deliveryCurrent]="deliveryCurrent"
      [basketSum]="basketSum"
      [basketCount]="basketCount"
      [currencyName]="currencyName"
      [isAdmin]="isAdmin"
      [wars]="wars"
      [showPartnerWarehouses]="showPartnerWarehouses"
      [urlParams]="urlParams"
      [categoriesSortedDeep]="categoriesSortedDeep"
      (buildNavigationMenuGoodsData)="buildNavigationMenuGoodsData()"
      (buildNavigationMenuFavoritesData)="buildNavigationMenuFavoritesData()"
      (buildNavigationMenuBasketData)="buildNavigationMenuBasketData()"
      (brandMenuShowRef)="brandsMenuShow()"
    />

    <div class="row expanded goods-data-table">
      <div class="column scrollable"
           #scrollableRef
           [class.block-scroll]="isDarkBackground">
        <table>
          <thead>
          <tr>
            <th class="adm-th" style="width: 68px" *ngIf="userSupper == 1">pack_id</th>
            <th>Найменування</th>
            <th>Артикул</th>
            <th style="width: 68px">Об'єм</th>
            <th style="width: 57px">Кільк. шт./л. в уп.</th>
            <th style="width: 117px">Умова</th>
            <th class="adm-th" *ngIf="isAdmin && roleId == 0">Кіл-ть</th>
            <th style="width: 77px">Склад</th>
            <th class="availability" style="width: 77px">Наявність</th>
            <th style="width: 87px">Ціна</th>
            <th style="width: 117px">Кіл-ть</th>
            <th class="added-favorites" style="width: 117px">Додати</th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngFor="let good of goodsData">
            <ng-container *ngFor="let sup of good.goodsSuppliers">
              <tr class="row-id" *ngIf="sup.count !== null" [class.assistant-highlight]="highlight.has(good.id)">
                <td class="good-pack-id adm-td" [class.good-name-hide]="!sup.showPackId" *ngIf="userSupper == 1">
                  <div (click)="packIdCopy(good.id)">
                    {{ good.id }}
                  </div>
                </td>
                <td class="bordertop good-mobile"
                    [class.good-name-hide]="!sup.showName">

                  <div class="good-mobile-head">
                    <a class="good-mobile-name"
                       [routerLink]="['/good', good.id]"
                       [queryParams]="{haveGoods: urlParams.haveGoods, includePartners: urlParams.includePartners}">
                      {{ good.name }}
                    </a>

                    <div class="good-mobile-actions">
                      <ng-container *ngIf="good.isset_params === '1'">
                        <button
                          type="button"
                          class="good-info"
                          aria-label="Інформація про товар"
                          (click)="openGoodInfoModal(good.id)">
                          <span class="question-mark" aria-hidden="true">i</span>
                        </button>
                      </ng-container>

                      <button
                        type="button"
                        *ngIf="sup.showName"
                        class="favorite-button"
                        [attr.aria-label]="sup.star ? 'Видалити з обраного' : 'Додати в обране'"
                        (click)="toggleFavorite(good.name, good.id, sup.star)"
                      >
                        <i class="fa favorite-icon"
                           aria-hidden="true"
                           [class.fa-heart]="sup.star"
                           [class.fa-heart-o]="!sup.star"
                           [class.favorite-icon-active]="sup.star">
                        </i>
                      </button>
                    </div>
                  </div>
                </td>

                <td class="bordertop good-desktop" [class.good-name-hide]="!sup.showName">
                  <a [routerLink]="['/good', good.id]"
                     [queryParams]="{haveGoods: urlParams.haveGoods, includePartners: urlParams.includePartners}">
                    {{ good.name }}
                  </a>
                  <ng-container *ngIf="good.isset_params === '1'">
                    <button
                      type="button"
                      class="good-info"
                      aria-label="Інформація про товар"
                      (click)="openGoodInfoModal(good.id)">
                      <span class="question-mark" aria-hidden="true">i</span>
                    </button>
                  </ng-container>

                  <a *ngIf="good.photos" (click)="openModalPhotos(good)">
                    <i class="fa fa-file-image-o"></i>
                  </a>

                  <p class="red" *ngIf="good.unbottled == 1">
                    Ціна вказана без урахування тари
                  </p>

                  <button
                    type="button"
                    *ngIf="sup.showName"
                    class="favorite-button"
                    [attr.aria-label]="sup.star ? 'Видалити з обраного' : 'Додати в обране'"
                    (click)="toggleFavorite(good.name, good.id, sup.star)"
                  >
                    <i class="fa favorite-icon"
                       aria-hidden="true"
                       [class.fa-heart]="sup.star"
                       [class.fa-heart-o]="!sup.star"
                       [class.favorite-icon-active]="sup.star">
                    </i>

                    <span class="favorite-tooltip" aria-hidden="true">Додати в обране</span>
                  </button>
                </td>
                <td [class.good-name-hide]="!sup.showName">
                  <div class="article article-desktop" [class.good-name-hide]="!sup.showName">
                    {{ good.firstArticle }}
                    <div class="prebulb">
                      <label *ngIf="good.lastArticles" (click)="articlesShow()">
                        {{ good.resultLastArticleGood.length }}
                      </label>
                      <div class="bulb" *ngIf="good.lastArticles || isArticlesShow"
                           [class.article-hide]="isArticleHide">
                        <div class="bulbarrow"></div>
                        <span>
                          <div *ngFor="let article of good.lastArticles">
                            {{ article }}
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="article prebulb article-mobile"
                       (click)="articleCopy(good.firstArticle)"
                       [class.good-name-hide]="!sup.showName"
                  >
                    {{ good.firstArticle }}
                    <label *ngIf="good.lastArticles" (click)="articlesShow()">
                      {{ good.resultLastArticleGood.length }}
                    </label>
                    <div class="bulb" *ngIf="good.lastArticles || isArticlesShow " [class.article-hide]="isArticleHide">
                      <div class="bulbarrow"></div>
                      <span>
                          <div *ngFor="let article of good.lastArticles" (click)="articleBulbCopy(article, $event)">
                            {{ article }}
                          </div>
                        </span>
                    </div>
                  </div>
                </td>
                <td>{{ good.litraj }}</td>
                <td>{{ good.cnt_in_pack }}</td>
                <td>
                  <ng-container *ngIf="sup.count > 0">
                    <div [innerHTML]="sup.expire"></div>
                  </ng-container>
                  <app-partner-wh-hint [sup]="sup"></app-partner-wh-hint>
                </td>
                <td class="adm-td" *ngIf="isAdmin && roleId == 0">
                  <div>
                    {{ sup.count }}
                  </div>
                </td>

                <td colspan="5" *ngIf="good.inventorization == 1">
                  На інвентаризації
                  <button class="button small" (click)="notifyInventoryFinished(good.id)">
                    повідомити в телеграм бот коли закінчиться інветарізація
                  </button>
                  <button class="button small btn-mobile" (click)="notifyInventoryFinished(good.id)">
                    повідомити в телеграм бот коли закінчиться інветарізація
                  </button>
                </td>

                <td class="label-color" *ngIf="good.inventorization == 0">
                  <!-- номер партнёра дописываем только к обезличенному названию («Партнер 86»):
                       закупщику бэк отдаёт реальное название склада, номер ему не нужен -->
                  {{ sup.supplier }}<ng-container *ngIf="sup.partner && !sup.supplierReal"> {{ sup.id }}</ng-container>
                  <div class="wh-name" *ngIf="sup.whName">{{ sup.whName }}</div>
                </td>

                <td class="missing-quantity" *ngIf="sup.count  > 9 && good.inventorization == 0">
                  >10
                </td>

                <td class="missing" *ngIf="sup.count  < 1 && good.inventorization == 0">
                  <a class="wait-delivery" (click)="showModalWaitDelivery()">Відсутній</a>
                </td>
                <td class="missing-quantity"
                    *ngIf="sup.count  > 0 && sup.count  < 10 && good.inventorization == 0">
                  {{ sup.count }}
                </td>

                <td disabled *ngIf="good.inventorization == 0">
                  {{ sup.price }} {{ currencyName }}
                </td>

                <td class="count-basket" *ngIf="good.inventorization == 0">
                  <div class="buttons-count-to-basket" *ngIf="sup.count > 0">
                    <span class="minus" (click)="minusCount(sup)">-</span>
                    <span
                      class="number contenteditable"
                      appContenteditable
                      [onlyNumber]="true"
                      [(ngModel)]="sup.countBasket">
                      </span>
                    <span class="plus" (click)="plusCount(sup)">+</span>
                  </div>
                </td>

                <td *ngIf="good.inventorization == 0">
                    <span *ngIf="sup.count > 0"
                          class="missing-quantity-mobile"
                          [class.fire]="sup.turnOn"
                          (click)="addToBasketMobile(good.id, sup, good.name)"

                    >
                      {{ sup.count > 9 ? ">10" : sup.count }} шт.
                    </span>
                  <a [class.add-to-basket]="sup.count > 0"
                     [class.fire]="sup.turnOn"
                     (click)="addToBasket(good.id, sup.countBasket, sup); sup.countBasket = 1">
                  </a>

                  <div class="add-to-favorite" *ngIf="sup.count <= 0">
                    <span>Відсутній</span>
                  </div>
                </td>
              </tr>
              <!-- Другие склады партнёра с остатком: раскрываются подсказкой в колонке «Умова» -->
              <ng-container *ngIf="sup.whExpanded && good.inventorization == 0">
                <tr appPartnerWhRow *ngFor="let wh of sup.others"
                    [good]="good" [sup]="sup" [wh]="wh"
                    [userSupper]="userSupper" [isAdmin]="isAdmin" [roleId]="roleId" [currencyName]="currencyName"
                    (add)="addToBasket(good.id, $event.countBasket, $event)"
                    (addMobile)="addToBasketMobile(good.id, $event, good.name)"></tr>
              </ng-container>
            </ng-container>
          </ng-container>
          </tbody>
        </table>

        <div *ngIf="isFavoriteMessageShow" class="favorite-message">
          {{ favoriteMessage }}
        </div>

        <div *ngIf="goodsData && goodsData.length <= 0" class="goods-not-found">
          {{ aiSearchError || 'Нічого не знайдено' }}
        </div>

        <div *ngIf="goodsData && goodsData.length" class="row pagination-desktop">
          <div class="column shrink paginate-buttons" [class.hide-max]="hide_pagination_max">
            <ul>
              <li
                *ngFor="let page of goods | paginate: {itemsPerPage: 30, currentPage: urlParams.page, totalItems: totalItems};"></li>
            </ul>
            <pagination-controls
              previousLabel="Назад"
              nextLabel="Далі"
              (pageChange)="changesPage($event)"
            >
            </pagination-controls>
          </div>
        </div>

        <div *ngIf="goodsData && goodsData.length" class="row pagination-mobile">
          <div class="column shrink paginate-buttons" [class.hide-max]="hide_pagination_max">
            <ul>
              <li
                *ngFor="let page of goods | paginate: {itemsPerPage: 30, currentPage: urlParams.page, totalItems: totalItems}"></li>
            </ul>
            <pagination-controls
              previousLabel=" "
              nextLabel=" "
              [maxSize]="maxSize"
              (pageChange)="changesPage($event)"
            >
            </pagination-controls>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<footer>
  <small>© 2010-{{ currentYear }}. Всі права захищені.</small>
</footer>

<div class="modalka-add-to-favorites" [class.modal-favorites-show]="isBasketModalShow">
  <a class="close-modal" (click)="closeModal()"></a>
  <h4 class="text-center">{{ basketModalData.name }}</h4>
  <div class="hidden">
    <input type="text">
    <input type="text">
  </div>
  <div class="plus-minus-atf">
    <span class="minus" (click)="minusBasketCountGoodModal()"></span>
    <input type="number" class="count" [(ngModel)]="basketModalData.count">
    <span class="plus" (click)="plusBasketCountGoodModal()"></span>
  </div>
  <p class="text-center">Додайте товар у кошик</p>
  <button class="button modal button-basket" [disabled]="isSendingMobileBasket" (click)="sendMobileBasket()">Додати у кошик</button>
</div>

<div class="modal-photos" [class.modal-photos-show]="isOpenModalPhoto">
  <a class="close-modal" (click)="closeModal()"></a>
  <div class="row">
    <div class="column">
      <h4 class="name">{{ goodName }}</h4>
    </div>
  </div>
  <div class="row photos" *ngFor="let photo of goodPhotos">
    <div class="column">
      <img src="/images/good_photos/{{photo.img}}">
    </div>
  </div>
</div>

<app-modal-non-returnable-items (agreeEvent)="agreeAddToBasket()" (agreeNotShowMoreEvent)="agreeNotShowMore()"/>

<app-modal-good-information/>

<div *ngIf="isCopyTextShow" class="success-mess-copy">Текст скопійовано в буфер обміну</div>

<div class="dark-layer" [class.modal-favorites-show]="isDarkBackground" (click)="closeModal()"></div>




